module.exports = __webpack_public_path__ + "static/media/background2.ca15c697.jpg";